import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { WEBSITE_API } from '../api/website-api';
import { WebsiteCreateInterface, WebsiteId, WebsiteInterface, WebsiteResponseApiInterface, WebsiteUpdateInterface } from '../types/website-interface';
import { WebsiteTemplateId } from 'modules/management/website-templates/types/website-templates-interface';
import { useWebsites } from './use-websites';
import { getUrlWebsiteEdit } from '../utils/get-url';
import { router } from 'next/client';
export const useWebsiteActions = () => {
  const $ = _c(21);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post,
      unprocessableContentHandler: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher: postFetcher,
    isFetching: postIsFetching
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.put,
      unprocessableContentHandler: _temp2
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fetcher: putFetcher
  } = useFetch(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      method: RequestMethodsEnum.delete,
      unprocessableContentHandler: _temp3
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fetcher: deleteFetcher
  } = useFetch(t2);
  const {
    mutate
  } = useWebsites();
  let t3;
  if ($[3] !== postFetcher) {
    t3 = (active, id) => postFetcher(`${WEBSITE_API}/websites/${id}/${active ? "deactivate" : "activate"}`, {});
    $[3] = postFetcher;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const updateStatus = t3;
  let t4;
  if ($[5] !== postFetcher) {
    t4 = data => postFetcher(`${WEBSITE_API}/websites`, data);
    $[5] = postFetcher;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const createWebsite = t4;
  let t5;
  if ($[7] !== mutate || $[8] !== postFetcher) {
    t5 = async (id_0, templateId) => {
      const responseData = await postFetcher(`${WEBSITE_API}/websites/${id_0}/choose-template`, {
        templateId
      });
      await mutate(data_0 => data_0 && {
        ...data_0,
        items: data_0.items.map(item => item.id === id_0 ? responseData : item)
      }, false);
      await router.push(getUrlWebsiteEdit(responseData?.homePage.pageContentId) ?? "");
    };
    $[7] = mutate;
    $[8] = postFetcher;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const chooseWebsiteTemplate = t5;
  let t6;
  if ($[10] !== putFetcher) {
    t6 = (id_1, data_1) => putFetcher(`${WEBSITE_API}/websites/${id_1}`, data_1);
    $[10] = putFetcher;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const updateWebsite = t6;
  let t7;
  if ($[12] !== deleteFetcher) {
    t7 = id_2 => deleteFetcher(`${WEBSITE_API}/websites/${id_2}`);
    $[12] = deleteFetcher;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const removeWebsite = t7;
  let t8;
  if ($[14] !== chooseWebsiteTemplate || $[15] !== createWebsite || $[16] !== postIsFetching || $[17] !== removeWebsite || $[18] !== updateStatus || $[19] !== updateWebsite) {
    t8 = {
      updateStatus,
      createWebsite,
      updateWebsite,
      removeWebsite,
      chooseWebsiteTemplate,
      postIsFetching
    };
    $[14] = chooseWebsiteTemplate;
    $[15] = createWebsite;
    $[16] = postIsFetching;
    $[17] = removeWebsite;
    $[18] = updateStatus;
    $[19] = updateWebsite;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
function _temp() {}
function _temp2() {}
function _temp3() {}